export const SETUP_CREATOR_TOOLS = 'creatorTools/setup';
